// src/pages/Vendor/Apply/components/ApplicationPending.tsx

import React from 'react';
import { Clock, Mail, CheckCircle, AlertCircle } from 'lucide-react';

const ApplicationPending: React.FC = () => {
    return (
        <div className="max-w-2xl mx-auto p-6 space-y-8">
            {/* Header */}
            <div className="text-center">
                <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Clock className="h-8 w-8 text-yellow-600 animate-pulse" />
                </div>
                <h1 className="text-2xl font-bold text-gray-900">Application Pending</h1>
                <p className="text-sm text-gray-500 mt-1">
                    Your vendor application is currently under review.
                </p>
            </div>

            {/* Status Card */}
            <div className="bg-white rounded-xl border border-gray-200 p-6 space-y-4">
                <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-yellow-100 rounded-full flex items-center justify-center">
                        <Clock className="h-5 w-5 text-yellow-600" />
                    </div>
                    <div>
                        <p className="font-medium text-gray-900">Under Review</p>
                        <p className="text-sm text-gray-500">We're reviewing your application</p>
                    </div>
                </div>

                <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                        <Mail className="h-5 w-5 text-blue-600" />
                    </div>
                    <div>
                        <p className="font-medium text-gray-900">Check Your Email</p>
                        <p className="text-sm text-gray-500">We'll notify you when a decision is made</p>
                    </div>
                </div>

                <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                        <CheckCircle className="h-5 w-5 text-green-600" />
                    </div>
                    <div>
                        <p className="font-medium text-gray-900">Next Steps</p>
                        <p className="text-sm text-gray-500">You'll be able to set up your store once approved</p>
                    </div>
                </div>
            </div>

            {/* Info Box */}
            <div className="bg-blue-50 border border-blue-200 rounded-xl p-4">
                <div className="flex items-start gap-3">
                    <AlertCircle className="h-5 w-5 text-blue-600 mt-0.5 flex-shrink-0" />
                    <div>
                        <p className="text-sm font-medium text-blue-800">What happens next?</p>
                        <ul className="text-sm text-blue-700 mt-1 space-y-1">
                            <li>• Our team reviews your application (1-3 business days)</li>
                            <li>• You'll receive an email with our decision</li>
                            <li>• If approved, you'll get access to your vendor dashboard</li>
                        </ul>
                    </div>
                </div>
            </div>

            {/* Actions */}
            <div className="space-y-3">
                <a
                    href="/dashboard"
                    className="block w-full text-center px-4 py-3 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors font-medium"
                >
                    Back to shopping
                </a>
            </div>
        </div>
    );
};

export default ApplicationPending;